import React from 'react';
import { ToastContainer } from 'react-toastify';

import ToastWrapper from './style';

const Toast = () => (
  <ToastWrapper>
    <ToastContainer
      limit={1}
      toastClassName="JNM-Toast"
    />
  </ToastWrapper>
);

export default Toast;
